import { useEffect } from 'react'

export function useThankYouRedirect(showThankYou: boolean) {
  useEffect(() => {
    if (!showThankYou) return

    const timer = setTimeout(() => {
      window.location.href = 'https://bo-smart.com/?utm_source=INTERVIEW_PLATFORM'
    }, 10000)

    return () => clearTimeout(timer)
  }, [showThankYou])
}
